module.exports = __webpack_public_path__ + "static/media/middle-left-4.3276fa6e.png";